import moment from "moment-timezone";
import ClientTags from "./ClientTags";

export default function ClientCheckinCard({
  checkin,
  doCheckinOut,
  doQuit,
  loading,
  isDebugOn,
  alreadyCheckedIn = false,
}) {
  return (
    <div className="row py-2 d-flex student position-relative" role="button">
      <div
        className={`col-12 p-4 bg-white shadow-sm rounded-4 border ${
          alreadyCheckedIn ? "opacity-50" : ""
        }`}
      >
        <div className="row">
          <div className="col-auto">
            {isDebugOn ? (
              <a
                className="p-0 m-0"
                href={`https://clients.mindbodyonline.com/app/clients/${checkin.clientId}`}
                target="_blank"
                rel="noreferrer"
              >
                {checkin.name}
              </a>
            ) : (
              <p className="p-0 m-0">{checkin.name}</p>
            )}
          </div>
          {isDebugOn && (
            <>
              <div className="col-auto">
                <ul className="small m-0 p-0 ms-2 text-start">
                  <li>{checkin.extra.currentServiceName}</li>
                  <li>
                    Activated:{" "}
                    {moment(checkin.extra.currentServiceActivationDate).format(
                      "MM/DD/YY"
                    )}
                  </li>
                  <li>Used times: {checkin.extra.currentServiceUsedTimes}</li>
                  <li>Have phone: {checkin.havePhone ? "Yes" : "No"}</li>
                </ul>
              </div>
              <div className="col-auto">
                <ul className="small m-0 p-0 ms-2 text-start">
                  {checkin.tags &&
                    checkin.tags.map((tag) => <li key={tag.id}>{tag.name}</li>)}
                </ul>
              </div>
            </>
          )}
          <div className="col d-flex justify-content-start align-items-center">
            {checkin.tags && <ClientTags tags={checkin.tags} />}
          </div>
          <div className="col-auto">
            <button
              type="button"
              className={`btn btn-lg ${
                alreadyCheckedIn
                  ? "btn-outline-secondary"
                  : "btn-outline-primary"
              }`}
              data-testid="checkin-btn"
              onClick={() =>
                doCheckinOut(
                  checkin.visitId,
                  !alreadyCheckedIn,
                  checkin.tags,
                  checkin.clientId,
                  checkin.havePhone
                )
              }
              disabled={loading[checkin.visitId]}
            >
              {alreadyCheckedIn ? "Undo check-in" : "Check in"}
            </button>
            {isDebugOn && (
              <a
                className="link mt-3 ms-3"
                onClick={() => doQuit(checkin.clientId, checkin.visitId)}
              >
                quit
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
